import { render, staticRenderFns } from "./AdvertisersTableDetailsModal.vue?vue&type=template&id=5bd686c6&scoped=true"
import script from "./AdvertisersTableDetailsModal.vue?vue&type=script&lang=ts"
export * from "./AdvertisersTableDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./AdvertisersTableDetailsModal.vue?vue&type=style&index=0&id=5bd686c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd686c6",
  null
  
)

export default component.exports